import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import "../assets/css/footer.css"; // Assuming you want to add custom styles in this file
import telegramIcon from "../assets/images/Telegram.png";
import whatsappIcon from "../assets/images/Whatsapp.png";
import mailIcon from "../assets/images/Mail.png";
import logo_color from "../assets/images/logo_color.png";
import logo_platform from "../assets/images/logo_platform.png";
import linkedin from "../assets/images/Linkedin.png";
import facebook from "../assets/images/Facebook.png";
import instagram from "../assets/images/Instagram.png";
import tiktok from "../assets/images/TikTok.png";
import twitter from "../assets/images/Twitter.png";

const Footer = () => {
  return (
    <div className="container-fluid footer-container">
      {/* First Section */}
      <Row className="footer-first-section">
        {/* First Part */}
        <Col xs={12} md={8} className="footer-first-part">
          <Row className="footer-row">
            {/* Global Headquarters */}
            <Row className="footer-row">
              <Col xs={12} md={3} className="footer-section">
                <span className="footer-first-section-title">
                  Global Headquarters
                </span>
                <ul className="footer-first-section-content">
                  <li className="content-txt">Ost Infinity</li>
                  <li className="content-txt">Taunusanlage 9-10</li>
                  <li className="content-txt">60239 Frankfurt am Main</li>
                  <li className="content-txt">Hessen</li>
                  <li className="content-txt">Germany</li>
                </ul>
              </Col>

              {/* Contact */}
              <Col
                xs={12}
                md={5}
                className="footer-section footer-section-contact"
              >
                <span className="footer-first-section-title">Contact</span>
                <div className="contact-container">
                  <div className="contact-item">
                    <img src={telegramIcon} alt="Telegram Icon" />
                    <span className="content-txt">Telegram</span>
                  </div>
                  <div className="contact-item">
                    <img src={mailIcon} alt="Zalo Icon" />
                    <span className="content-txt">Zalo</span>
                  </div>
                  <div className="contact-item">
                    <img src={whatsappIcon} alt="WeChat Icon" />
                    <span className="content-txt">WeChat</span>
                  </div>
                  <div className="contact-item">
                    <img src={mailIcon} alt="Mail Icon" />
                    <span className="content-txt">sales@ostinfinity.net</span>
                  </div>
                </div>
              </Col>

              {/* Resources */}
              <Col xs={12} md={4} className="footer-section">
                <span className="footer-first-section-title">Resources</span>
                <ul className="footer-first-section-content">
                  <li className="content-txt">Careers</li>
                </ul>
              </Col>
            </Row>
          </Row>
          <Row className="footer-row">
            <Col xs={12} md={6} className="footer-section-logocolor">
              <img src={logo_color} alt="logo_color" className="logo_color" />
              <span className="logo_color_ST">ST</span>
              <span className="logo_color_INFINITY">INFINITY</span>
            </Col>
            <span className="footer-section-logocolor fw-light">
              Identity-First Platforms
            </span>
          </Row>
        </Col>

        {/* Second Part - Logo Image */}
        <Col xs={12} md={4} className="footer-logo">
          <Row className="footer-row">
            <Button className="btn_subscribe">
              <span>SUBSCRIBE FOR LATEST UPDATES</span>
            </Button>
            <img src={logo_platform} alt="Logo" className="footer-logo-img" />
          </Row>
        </Col>
      </Row>

      {/* Second Section */}
      <Row className="footer-second-section">
        {/* First Part - Text */}
        <Col xs={12} md={3} className="footer-text">
          <p>© 2025 All Rights Reserved</p>
        </Col>

        {/* Second Part - Links (Privacy & Terms) */}
        <Col xs={12} md={5} className="footer-links">
          <ul className="footer-cookie">
            <li>
              <a href="/privacy-policy">Privacy & Cookie Policy</a>
            </li>
            <li>
              <a href="/terms-of-use">Terms of Use</a>
            </li>
            <li>
              <a href="/human-rights">Ost Infinity Human Rights Statement</a>
            </li>
          </ul>
        </Col>

        {/* Third Part - Image Links */}
        <Col xs={12} md={4} className="footer-image-links">
          <Row className="footer-links-content">
            <Col xs={1} className="footer-links-item">
              <a href="https://www.linkedin.com">
                <img src={linkedin} alt="Linkedin" className="footer-icon" />
              </a>
            </Col>
            <Col xs={1} className="footer-links-item">
              <a href="https://www.facebook.com">
                <img src={facebook} alt="Facebook" className="footer-icon" />
              </a>
            </Col>
            <Col xs={1} className="footer-links-item">
              <a href="https://www.instagram.com">
                <img src={instagram} alt="Instagram" className="footer-icon" />
              </a>
            </Col>
            <Col xs={1} className="footer-links-item">
              <a href="https://www.tiktok.com">
                <img src={tiktok} alt="Tiktok" className="footer-icon" />
              </a>
            </Col>
            <Col xs={1} className="footer-links-item">
              <a href="https://www.twiiter.com">
                <img src={twitter} alt="Twitter" className="footer-icon" />
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
